import FilterGroupCollection from './FilterGroupCollection.jsx';

export default FilterGroupCollection;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/index.js